import { render, staticRenderFns } from "./AdminListaSegnalazioni.vue?vue&type=template&id=817b6eba&scoped=true&lang=pug&"
import script from "./AdminListaSegnalazioni.vue?vue&type=script&lang=ts&"
export * from "./AdminListaSegnalazioni.vue?vue&type=script&lang=ts&"
import style0 from "./AdminListaSegnalazioni.vue?vue&type=style&index=0&id=817b6eba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817b6eba",
  null
  
)

export default component.exports